// Port of api/fuel/app/classes/insights/players/duration.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'duration',
	requires: ['init'],
	types: [Constants.TYPE_USER],
	insight: ['duration.sort'],
	detail: ['duration'],
	run: function(type, owner, userIndex, detail, filter) {
		var data = {
			duration: [],
			total: 0
		}
		var sorting = (filter && filter['duration.sort']) ? filter['duration.sort'] : 'total'
		var players = (this._data.players || []).filter(function(player) {
			return player.durationPlays > 0
		})
		var limit = detail ? 250 : 5

		players = Util.sort_by_field(players, (sorting === 'avg') ? 'avgDuration' : 'totalDuration', 'desc')
		data.total = players.length
		if (players.length > limit) players = players.slice(0, limit)

		for (var i = 0; i < players.length; i++) {
			data.duration.push({
				id: parseInt(players[i].id, 10) || 0,
				slug: players[i].slug,
				name: players[i].primaryName,
				username: players[i].username,
				count: (sorting === 'avg') ? Math.round((players[i].avgDuration / 60) * 10) / 10 : Math.ceil(players[i].totalDuration / 60),
				plays: players[i].durationPlays
			})
		}

		return {
			duration: data
		}
	}
})
